<template>
	<div>
		<!-- Mobile Menu -->
		<div id="mobile-menu" class="flex items-center lg:hidden min-h-[50px]">
			<div class="px-6 h-full flex items-center justify-center border-r" style="border-color: var(--border);">
				<div @click="mobileIsOpen = !mobileIsOpen" class="cursor-pointer">
	            	<inline-svg name="menu"></inline-svg>
	            </div>

	            <div v-if="mobileIsOpen">
	            	<div class="absolute top-0 left-0 w-full h-full flex z-50">
	            		<div>
					    	<div class="flex items-center justify-center w-64 h-20 p-4 border-b-2 shadow-md" style="background-color: var(--primary); border-color: var(--border);">
					        	<img src="/img/logos/reoptimizer-white.png" alt="Reoptimizer">
					        	<div @click="mobileIsOpen = false" class="absolute top-5 right-3 cursor-pointer">
					        		<inline-svg name="close" classes="p-2 w-10 h-10 fill-current rounded-full hover:bg-black hover:opacity-50" style="color: var(--primary-foreground);"></inline-svg>
					        	</div>
					    	</div>
					    	<div class="py-6 px-5 flex flex-col gap-y-5" style="background-color: var(--card);">
								<a v-if="$gate.isAdmin()" class="flex items-center theme-mobile-nav-item" :class="{ 'theme-mobile-nav-active': rootRoute == 'admin' }" href="/admin">
									<img src="/img/theme/v1/nav/admin.svg" class="w-8 h-8 theme-mobile-nav-icon" alt="Admin" />
									<p class="ml-2 text-lg theme-mobile-nav-label">Admin</p>
								</a>

								<a class="flex items-center theme-mobile-nav-item" :class="{ 'theme-mobile-nav-active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in filteredLinks" :key="routeName">
									<img :src="row.icon" class="w-8 h-8 theme-mobile-nav-icon" :alt="row.label" />
									<p class="ml-2 text-lg theme-mobile-nav-label" v-html="row.label"></p>
								</a>

								<!-- More Menu Items in Mobile -->
								<a class="flex items-center theme-mobile-nav-item" :class="{ 'theme-mobile-nav-active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in filteredMoreMenuLinks" :key="'more-' + routeName">
									<img :src="row.icon" class="w-8 h-8 theme-mobile-nav-icon" :alt="row.label" />
									<p class="ml-2 text-lg theme-mobile-nav-label" v-html="row.label"></p>
								</a>
							</div>
	                	</div>
	                	<div @click="mobileIsOpen = false" class="flex-1 bg-black opacity-50"></div>
	                </div>
	            </div>
	        </div>
		</div>

		<!-- Desktop Navigation -->
		<ul class="ml-6 hidden lg:flex flex-1 items-center justify-center gap-x-2 themed-navigation-list">
			<a v-if="$gate.isAdmin()" class="theme-nav-item flex flex-col items-center px-3 py-2 rounded-lg" :class="{ 'theme-nav-active': rootRoute == 'admin' }" href="/admin">
				<img src="/img/theme/v1/nav/admin.svg" class="w-6 h-6 theme-nav-icon" alt="Admin" />
				<p class="pt-1.5 text-xs font-medium theme-nav-label">Admin</p>
			</a>

			<a class="theme-nav-item flex flex-col items-center px-3 py-2 rounded-lg" :class="{ 'theme-nav-active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in filteredLinks" :key="routeName">
				<img :src="row.icon" class="w-6 h-6 theme-nav-icon" :alt="row.label" />
				<p class="pt-1.5 text-xs font-medium theme-nav-label" v-html="row.label"></p>
			</a>

			<!-- Show More Menu items directly on XL+ screens (≥ 1280px) -->
			<a class="hidden xl:flex theme-nav-item flex-col items-center px-3 py-2 rounded-lg" :class="{ 'theme-nav-active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in filteredMoreMenuLinks" :key="'direct-' + routeName">
				<img :src="row.icon" class="w-6 h-6 theme-nav-icon" :alt="row.label" />
				<p class="pt-1.5 text-xs font-medium theme-nav-label" v-html="row.label"></p>
			</a>

			<!-- More Menu Dropdown - Only visible on laptop screens (1024-1279px) -->
			<div class="relative theme-more-menu xl:hidden" v-if="Object.keys(filteredMoreMenuLinks).length > 0">
				<div @click="moreMenuOpen = !moreMenuOpen" class="theme-nav-item flex flex-col items-center px-3 py-2 rounded-lg cursor-pointer" :class="{ 'theme-nav-active': isMoreMenuActive }">
					<svg class="w-6 h-6 theme-nav-icon" viewBox="0 0 24 24" fill="currentColor">
						<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
					</svg>
					<p class="pt-1.5 text-xs font-medium theme-nav-label">More</p>
				</div>

				<!-- Dropdown Menu -->
				<div v-if="moreMenuOpen" class="absolute top-full left-0 mt-2 w-48 rounded-lg shadow-lg z-50 theme-more-dropdown" style="background-color: var(--card); border: 1px solid var(--border);">
					<a v-for="(row, routeName) in filteredMoreMenuLinks" :key="routeName" :href="row.url" class="flex items-center px-4 py-3 hover:bg-accent transition-colors first:rounded-t-lg last:rounded-b-lg">
						<img :src="row.icon" class="w-5 h-5 mr-3 theme-more-dropdown-icon" :alt="row.label" />
						<span class="text-sm font-medium" style="color: var(--foreground);" v-html="row.label"></span>
					</a>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'ThemedNavigation',
		components: {
		},
		props: {
			currentRoute: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				mobileIsOpen: false,
				moreMenuOpen: false,
				userModules: [],
				links: {
					estimatedWaste: {
						label: 'Waste',
						url: '/estimated-waste',
						icon: '/img/theme/v1/nav/waste.svg'
					},

					dashboard: {
						label: 'Dashboard',
						url: '/',
						icon: '/img/theme/v1/nav/dashboard.svg'
					},

                    reatlas: {
                        label: 'REatlas',
                        url: '/reatlas',
                        icon: '/img/theme/v1/nav/reatlas.svg'
                    },

                    // Temporarily hidden - old CRESiteIQ link
                    // cresiteiq: {
                    //     label: 'CRESiteIQ&trade;',
                    //     url: '/cresiteiq',
                    //     icon: '/img/theme/v1/nav/cresiteiq.svg'
                    // },

                    cresiteiq2: {
                        label: 'CRESiteIQ&trade;',
                        url: '/cresiteiq2',
                        icon: '/img/theme/v1/nav/cresiteiq.svg'
                    },

					sites: {
						label: 'Sites',
						url: '/sites',
						icon: '/img/theme/v1/nav/sites.svg'
					},

					projects: {
						label: 'Projects',
						url: '/projects',
						icon: '/img/theme/v1/nav/projects.svg'
					},

					tasks: {
						label: 'Tasks',
						url: '/tasks',
						icon: '/img/theme/v1/nav/tasks.svg'
					},

					'lease-ai-files': {
						label: 'AI Tools',
						url: '/lease-ai-files',
						icon: '/img/theme/v1/nav/lease-ai.svg'
					},

					'listing-search': {
						label: 'Listing Search',
						url: '/listing-search',
						icon: '/img/theme/v1/nav/lease-ai.svg'
					},
				},
				moreMenuLinks: {
					'project-finder': {
						label: 'Project Finder',
						url: '/project-finder',
						icon: '/img/theme/v1/nav/search.svg'
					},

					reports: {
						label: 'Reports',
						url: '/reports',
						icon: '/img/theme/v1/nav/reports.svg'
					},

					documents: {
						label: 'Documents',
						url: '/documents',
						icon: '/img/theme/v1/nav/documents.svg'
					},
				}
			}
		},

		methods: {
			processModulePermissions() {
				if (!window.user || !window.user.module_permissions) {
					this.userModules = [];
					return;
				}
				
				// module_permissions structure: { moduleId: { enabled: bool, slug: string } }
				this.userModules = Object.entries(window.user.module_permissions).map(([moduleId, module]) => ({
					id: parseInt(moduleId),
					slug: module.slug,
					enabled: module.enabled === true
				}));
				
				console.log('ThemedNavigation - Processed modules:', this.userModules);
			},
			
			toggleMobileMenu() {
				this.mobileIsOpen = !this.mobileIsOpen;
			},

			closeMoreMenu(event) {
				if (!this.$el.querySelector('.theme-more-menu')?.contains(event.target)) {
					this.moreMenuOpen = false;
				}
			}
		},

		mounted() {
			document.addEventListener('click', this.closeMoreMenu);
		},

		beforeDestroy() {
			document.removeEventListener('click', this.closeMoreMenu);
		},

		created() {
			this.processModulePermissions();
			
			if (window.user) {
				this.processModulePermissions();
			} else {
				const checkUser = setInterval(() => {
					if (window.user) {
						clearInterval(checkUser);
						this.processModulePermissions();
					}
				}, 100);
			}
		},

		computed: {
			rootRoute() {
				return this.currentRoute.split('.')[0];
			},
			
			userModulePermissions() {
				if (!window.user || !window.user.module_permissions) {
					return [];
				}
				return Object.values(window.user.module_permissions);
			},

			isMoreMenuActive() {
				return ['project-finder', 'reports', 'documents', 'toolbox'].includes(this.rootRoute);
			},

			filteredMoreMenuLinks() {
				// Toolbox users don't see more menu
				if (this.$gate && this.$gate.isToolboxUser && this.$gate.isToolboxUser()) {
					return {};
				}
				
				const links = {...this.moreMenuLinks};
				
				// Admins see everything in more menu, including Toolbox
				if (this.$gate?.isAdmin()) {
					// Add Toolbox to more menu for admin users
					links.toolbox = {
						label: 'Toolbox',
						url: '/toolbox',
						icon: '/img/theme/v1/nav/search.svg'
					};
					return links;
				}

				// Brokers don't see more menu items
				if (this.$gate?.isBroker()) {
					return {};
				}

				// Client users see filtered links based on module permissions
				if (this.$gate?.isClientUser()) {
					const filtered = {};
					
					Object.entries(links).forEach(([key, link]) => {
						const hasAccess = this.userModules.some(module => 
							module.slug === key && module.enabled
						);
						
						if (hasAccess) {
							filtered[key] = link;
						}
					});
					
					return filtered;
				}
				
				// Default: show all
				return links;
			},
			
			filteredLinks() {
				// Debug logging
				console.log('ThemedNavigation - User:', window.user);
				console.log('ThemedNavigation - $gate:', this.$gate);
				console.log('ThemedNavigation - isToolboxUser:', this.$gate?.isToolboxUser?.());
				
				// Special case: Toolbox users see only Toolbox
				if (this.$gate && this.$gate.isToolboxUser && this.$gate.isToolboxUser()) {
					console.log('ThemedNavigation - Returning toolbox menu only');
					return {
						toolbox: {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/theme/v1/nav/dashboard.svg'
						}
					};
				}
				
				const links = {...this.links};
				
				// Admins see everything (Toolbox will be in More dropdown, not main nav)
				if (this.$gate?.isAdmin()) {
					// Don't add Toolbox to main nav for admins - it's in More dropdown
					return links;
				}

				// Brokers see dashboard, sites, and projects
				if (this.$gate?.isBroker()) {
					const brokerLinks = {
						dashboard: links.dashboard,
						sites: links.sites,
						projects: links.projects
					};
					
					// Check if broker has Toolbox module enabled
					const hasToolboxAccess = this.userModules.some(module => 
						module.slug === 'toolbox' && module.enabled
					);
					
					if (hasToolboxAccess) {
						brokerLinks.toolbox = {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/theme/v1/nav/dashboard.svg'
						};
					}
					
					return brokerLinks;
				}

				// Client users see filtered links based on module permissions
				if (this.$gate?.isClientUser()) {
					const filtered = {};
					
					if (links.dashboard) {
						filtered.dashboard = links.dashboard;
					}

					if (links['lease-ai-files']) {
						filtered['lease-ai-files'] = links['lease-ai-files'];
					}
					
					Object.entries(links).forEach(([key, link]) => {
						if (key === 'dashboard' || key === 'lease-ai-files' || link.adminOnly) {
							return;
						}
						
						const hasAccess = this.userModules.some(module => 
							module.slug === key && module.enabled
						);
						
						if (hasAccess) {
							filtered[key] = link;
						}
					});
					
					// Check if user has Toolbox module enabled
					const hasToolboxAccess = this.userModules.some(module => 
						module.slug === 'toolbox' && module.enabled
					);
					
					if (hasToolboxAccess) {
						filtered.toolbox = {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/theme/v1/nav/dashboard.svg'
						};
					}
					
					return filtered;
				}
				
				// Default: show all non-admin links
				return Object.fromEntries(
					Object.entries(links).filter(([_, link]) => !link.adminOnly)
				);
			}
		}
	}
</script>
